import { render, staticRenderFns } from "./fair-product-view.vue?vue&type=template&id=495e0414&scoped=true&"
import script from "./fair-product-view.vue?vue&type=script&lang=js&"
export * from "./fair-product-view.vue?vue&type=script&lang=js&"
import style0 from "./fair-product-view.vue?vue&type=style&index=0&id=495e0414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495e0414",
  null
  
)

export default component.exports